import startCase from 'lodash/startCase';

export default function generateModuleTypeSelectOption(category) {
  return {
    label: startCase(category),
    value: category,
  };
}
